import React from "react";
import FeatherIcon from "feather-icons-react";
import axios from "axios";
import { useGoogleLogin } from "@react-oauth/google";

import sampleAvtar from "../../assets/images/sampleAvtar.png";
import settingsIcon from "../../assets/images/other/ic_settings.png";
import balanceIcon from "../../assets/images/ic_balance_outline.png";
import logoutIcon from "../../assets/images/other/ic_logout.png";
import googleIcon from "../../assets/images/socialMediaIcons/google.png";
import discordIcon from "../../assets/images/socialMediaIcons/ic_wallet_discord.png";

import { LogoutAction, ConnectAccountAction } from "../../redux/actions/authActions";
import { DISCORD_OAUTH_URL } from "../../config/authConfig";
import { useNavigate } from "react-router-dom";
import { useAccount, useDisconnect } from "wagmi";
import { useDispatch, useSelector } from "react-redux";
import AvatarCanvas from "../../views/settings/elements/AvatarCanvas";

const UserMenuElement = ({ user }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isSilentLogin } = useSelector((state) => state.Auth);

  const { disconnect, disconnectAsync } = useDisconnect();
  const { isConnected } = useAccount();

  const handleLogout = () => {
    console.log("Log out func work...!");
    if(isConnected){
      console.log("Log out when is connected.")
      disconnectAsync().then(() => {
        localStorage.clear();
        dispatch(LogoutAction(() => {
          disconnect();
          navigate("/");
        }));
      });
    }else{
      console.log("Log out when is not connected.")
      dispatch(LogoutAction(() => {
        localStorage.clear();
        navigate("/");
      }));
    }
  };

  const handleGoogleSync = useGoogleLogin({
    ux_mode: 'popup',
    onSuccess: async (res) => {
      const userInfo = await axios.get("https://www.googleapis.com/oauth2/v3/userinfo", {
        headers: { Authorization: `Bearer ${res?.access_token}` },
      });
      dispatch(ConnectAccountAction(
        {
          email: userInfo?.data?.email,
          name: userInfo?.data?.name,
          profileImage: userInfo?.data?.picture,
          typeOfLogin: "akedo_social",
          verifier: "Google",
          verifierId: userInfo?.data?.sub,
          token: res?.access_token,
        },
        () => navigate('/')
      ));
    },
    onError: (error) => console.error('[UserMenuElement] Google sync error:', error),
  });

  const handleDiscordSync = () => {
    localStorage.setItem('discord_connect_account', 'true');
    window.location.href = DISCORD_OAUTH_URL.replace(
      "DISCORD_REDIRECT_URI",
      encodeURIComponent(window.location.origin + "/discord/logincallback")
    );
  };

  return (
    <>
      <div className="userProfile z-10 absolute bg-[#343337] w-[200px] mt-15 text-white text-center mt-[360px] p-[15px] rounded-[10px] right-0">
        <AvatarCanvas
          key={""}
          onlyView={true}
          className="h-20 w-20 mx-auto my-0 rounded-[50%] overflow-hidden flex justify-center items-center"
          id={`avatarCanvas-${""}`}
          layerCode={user.avatar ? user.avatar : sampleAvtar}
          width={80}
          height={80}
        />
        <h5 className="text-[18px] mx-0 my-2.5">{user?.username}</h5>
        <div className="mb-3">
          <span className="bg-[#00e6f4] text-black inline-block px-[30px] py-2.5 rounded-[30px] flex justify-center cursor-pointer">            
            <img
              src={balanceIcon}
              alt="settingsIcon"
              title="settingsIcon"
              className="icon-dual text-[#000] mt-[4px] mr-[5px] text-[26px] font-semibold w-[20px] h-[14px]"
            />
            {user?.balance}
          </span>
        </div>
        <div
          className="settingMenubtn  uppercase px-[5px] py-2 rounded-[30px] mb-2 cursor-pointer flex items-center justify-center"
          style={{ border: "1px solid #00e6f4" }}
          onClick={(e) => {
            navigate(`/settings`);
          }}
        >
          <img
            src={settingsIcon}
            alt="settingsIcon"
            title="settingsIcon"
            className="mr-[10px]"
          />
          settings
        </div>

        {isSilentLogin ? (
          <>
            <p className="text-[11px] text-[#999] mb-2 mt-1">Sync to save progress across devices</p>
            <h5 className="text-[18px] mx-0 my-2.5">Sync with:</h5>
            <div
              className="syncMenubtn uppercase px-[5px] py-2 rounded-[30px] mb-2 cursor-pointer flex items-center justify-center"
              style={{ border: "1px solid #00e6f4" }}
              onClick={() => handleGoogleSync()}
            >
              <img src={googleIcon} alt="googleIcon" className="mr-[10px] w-[18px]" />
              Google
            </div>
            <div
              className="syncMenubtn uppercase px-[5px] py-2 rounded-[30px] cursor-pointer flex items-center justify-center"
              style={{ border: "1px solid #00e6f4" }}
              onClick={handleDiscordSync}
            >
              <img src={discordIcon} alt="discordIcon" className="mr-[10px] w-[18px]" />
              Discord
            </div>
          </>
        ) : (
          <div
            className="logoutMenubtn uppercase px-[5px] py-2 rounded-[30px] cursor-pointer flex items-center justify-center"
            style={{ border: "1px solid #00e6f4" }}
            onClick={handleLogout}
          >
            <img
              src={logoutIcon}
              alt="logoutIcon"
              title="logoutIcon"
              className="mr-[10px]"
            />
            LOG OUT
          </div>
        )}
      </div>

      <div className="overlayLoginOption"></div>
    </>
  );
};

export default UserMenuElement;

